import { FC } from "react";
import { isFunction } from "lodash";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useAiSaasOutputContainer } from "../../container";
import { AISaasToolbar } from "../../components";

const AISaasOutpuItem: FC<AISaasOutput.ItemProps> = props => {
  const { onClickSortable, isShare, disabledDnd, activeId } = useAiSaasOutputContainer();
  const { id, children } = props;

  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    disabled: !id,
    id: id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  const sortableProps = { id, attributes, listeners, setNodeRef, style };
  const renderChildProps = { sortableProps };

  const renderChild = () => {
    // if (activeId === id) {
    //   return <AISaasActive />;
    // }
    return isFunction(children) ? children(renderChildProps) : children;
  };

  return (
    <AISaasToolbar
      hideHandle={disabledDnd || isShare}
      style={style}
      sortableProps={sortableProps}
      onClickSortable={onClickSortable}
    >
      {renderChild()}
    </AISaasToolbar>
  );
};

export default AISaasOutpuItem;
